<template>
  <div class="project" v-drag> 
    <div  role="document">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title">-- {{data_title}} --</span>
          <span aria-hidden="true" class="modal-span" @click="close">&times;</span>
        </div>
        <div class="modal-body">
          <table class="table table-hover text-nowrap">
            <tbody>
              <tr v-for="(child_list,index) in body_data" :key="index" @click="col_check(child_list.id)">
                <template > 
                    <td>{{child_list.name}}</td>
                    <td>{{child_list.id}}</td>
                </template>
                <td ><input type="radio" v-model="check_data" :value="child_list.id"></td> 
              </tr>                   
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default btn-default-close" data-dismiss="modal" @click="cancel_selection">{{cancel}}</button>
          <button type="button" class="btn btn-default-determine" @click="determine()">{{confirm}}</button>
        </div>
        <div class="loading" v-if="anate"><i class="fa fa-spin fa-spinner"></i></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import api from "../api/index.js"
  export default {
    name: 'Project',
    components: {
    },
    computed:{
      confirm(){
        return this.$attrs.language_pack[this.sel_language].confirm
      },
      cancel(){
        return this.$attrs.language_pack[this.sel_language].cancel
      },
      ...mapState({
        sel_language:'sel_language'
      })
    },
    data(){
      return {
       //加载状态
      anate:false,
      body_data:[
          {name:'是',id:'1'},
          {name:'否',id:'0'},
          {name:'空',id:''},
      ],
      btn_check:'',
      check_data:[],
      //数据列表
    //   list_data:5,
    //   show_data:[],
      btn_data:this.rule_data,
      data_title:'是否为测试项',
      tb_key:'',
      }
    },
    mounted(){
        this.is_checked();
    },
    props:[
      'ppr_action',
      'ppr_action_param',
      'rule_data',
      'key_s'
    ],
    methods:{
        //读取输入框中的值如果有值就选中对应的复选框
        is_checked(){
            if(this.rule_data){
                this.check_data=this.rule_data
            }
        },
        //点击tr元素选中checkbox标签
       col_check(i){
        this.check_data=i
      },
      //点击关闭图标
      close(){
        this.$emit('close_project')
      },
      //点击取消
      cancel_selection(){
        this.check_data=null;
        // this.btn_check='';
      },
      //点击确定
      determine(){    
        var data=null;
        data=this.check_data;
        this.$emit('input_data',data) 
      },
    },
    directives: {
      drag: {
        inserted(el) {
          let drag_Box = el; //获取当前元素
          let dragBox = document.getElementsByClassName('modal-header')[0];
          dragBox.onmousedown = e => {
            //算出鼠标相对元素的位置
            let disX = e.clientX - drag_Box.offsetLeft;
            let disY = e.clientY - drag_Box.offsetTop;
            document.onmousemove = e => {
              //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
              let left = e.clientX - disX;
              let top = e.clientY - disY;
              //移动当前元素
              drag_Box.style.left = left + "px";
              drag_Box.style.top = top + "px";
            };
            document.onmouseup = e => {
              //鼠标弹起来的时候不再移动
              document.onmousemove = null;
              //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
              document.onmouseup = null;
            };
          };
        }
      }
    }
  }
</script>
<style scoped>
  .modal-content{
	min-width: 500px;
}
  .modal-header{
    cursor: move;
  }
  .modal-body{
    max-height: 500px;
    overflow: auto;
  }
  .table>tbody>tr>td {
     text-align: center;
  } 
  .table>thead>tr>th {
      text-align: center;
 }
  	.loading{
		z-index: 1000;
		font-size: 50px;
		position: absolute;
		color: rgb(138, 132, 132);
		top: 50%;
		left: 50%;
		/* transform: translate(-50%, -50%); */
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px));
		text-align: center;
	}
	.project{
    position: fixed;
    top: 50%;
    left: 50%;
    z-index:999;
    /* transform: translate(-50%, -50%); */
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px));
  }
 .modal-header{
		background:#ebecf0;
		height:40px
	}
 .modal-span{
		font-size:20px;
		margin-top:-14px;
		cursor:pointer
	}
	.modal-title{
		line-height:1px
	}
  .btn-default-close{
    color:#007bff;
		font-size:12px;
		border:1px solid #808080;
		padding:4px;
		/* margin-right: 393px; */
  }
  .modal-footer{
    justify-content: space-between;
    /* width: 500px; */
  }
  .btn-default-determine{
    color:#007bff;
		font-size:12px;
		border: 1px solid rgb(128, 128, 128);
		padding: 4px;
  }
  td{
    font-size: 12px;
  }
  </style>